export enum EFloodlightHologramMountingType {
  FHMT_Ground,
  FHMT_Wall,
}
